<template>
  <div class="wrapper">
    <div>
      <div class="card">
        <CRow >
          <CCol sm="5" lg="12">
            <div class="card-body">
              <CRow>
                  <CCol lg="4" class="mr-5">
                    <div id="app">
                      <h5>{{currentDate()}}</h5>
                      <h2>{{ showTime }}</h2>
                    </div>
                </CCol>
              </CRow>
            <CRow>
              </CRow>               
          </div>
          </CCol>
        </CRow>
      </div>
    <!-- <CRow lg="12" >
      <CCol lg="4" v-for="item in itemsLog" :key="item.id" >
        <CCol>
          <CCard class="card" v-if="item.action == 'queued'"  >
            <CRow>
              <CCol>
                <CCardBody>
                  <CRow>
                    <CCol>
                      <CCallout color="success">
                        <row >
                          <p > Name: <b> {{item.name }} </b> </p>
                          <p >Status:<b> {{item.action}}</b> </p>
                          <p> Timestamp: <b>{{item.log_time}} </b> </p>
                        </row>
                      </CCallout>
                      <CButton type="submit"  @click="result_hide = !result_hide"   color="danger">Check Out</CButton>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCol>
            </CRow>
          </CCard>  
        </CCol>
      </CCol>
    </CRow>  -->
    <ikidmodalcheckout></ikidmodalcheckout>
    <alertmodal></alertmodal>
    </div>
  </div>
</template>

<script >
import ikid from '@/services/ikid'
import ikidmodalcheckout from './kids_checkout.vue';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';

const token = localStorage.getItem('token');

export default {
  name: 'iKidsTable',
  components: { ikidmodalcheckout, alertmodal,  },
  data(){
    return{
      form:{
        name:'',
      },
      showMilitary: false,
      showTime: '',
      now: new Date(),
      updateSubmit: false,
      largeModal:false,
      datas:[], 
      itemsLog: [],
      metaLog: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      permission: true,
      //end
    }
  },

  

  created() {
      //this.loadData()
      this.beforeDestroy()
  },
  
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();  
      }
    });
    this.showTheTime()

   },
   
  methods: {
    beforeDestroy(){
    EventBus.$off('OPEN_MODAL_IKID_CHECK', this.listener)
    EventBus.$off('OPEN_MODAL_IKID_QUEUE', this.listener)
    EventBus.$off('OPEN_MODAL_IKID_CHECKOUT', this.listener)
   },
   currentDate() {
    var  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    
      const current = new Date();
      const date = current.getDate() +' '+ months[current.getMonth()]+' '+current.getFullYear()
      return date;
    },
   showTheHours(theHour) {
      var vm = this
      if (vm.showMilitary|| (theHour > 0 && theHour < 13)) {
        if (theHour == "") theHour = 12;
        return (theHour);
      }
      if (theHour == 0) {
        return (12);
      }
      return (theHour);
    },
    showZeroFilled(inValue) {
      if (inValue > 9) {
        return "" + inValue;
      }
      return "0" + inValue;
    },
    showAmPm() {
      var vm = this
      if (vm.showMilitary) {
        return ("");
      }
      if (vm.now.getHours() < 12) {
        return (" AM");
      }
      return (" PM");
    },
    
    showTheTime() {
      var vm = this
      vm.now = new Date
      vm.showTime = vm.showTheHours(vm.now.getHours()) + ":" + vm.showZeroFilled(vm.now.getMinutes()) + ":" + vm.showZeroFilled(vm.now.getSeconds()) + vm.showAmPm()
      setTimeout(vm.showTheTime,1000)
    },
    openCheckOut: function(uuid) {
      var params = {
            title: "Check Out",
            mode: "detail",
            data: uuid
         };
         EventBus.$emit("OPEN_MODAL_IKID_CHECKOUT", params);
      //SET END
    },

    

    loadData() {

      var paramsLog = {
        //headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }

      ikid.getIkidActivity(paramsLog)
      .then(res => {
        console.log(res,'res')
          let getData = res.data
          this.itemsLog = getData.data
          //this.is_active = res.is_active
          this.metaLog = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active,
              
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      });
  
    },


  }
}
</script>